import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseQueryOptions, useQuery } from 'react-query'
import { BrandPlan } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

type Data = BrandPlan

export const fetchCurrentBrandPlan = async ({ workspaceId, signal }: { workspaceId: number; signal?: AbortSignal }) => {
  const res = await sendToApi<{ brand_plan: BrandPlan }>(`/w/${workspaceId}/brand_plans/current`, { signal })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.brand_plan
}

export const useCurrentBrandPlan = (options?: UseQueryOptions<Data> & { workspaceId?: number }) => {
  const workspaceId = useCurrentWorkspaceId()
  const workspaceIdToUse = options?.workspaceId || workspaceId

  return useQuery<Data>(
    ['workspaces', workspaceIdToUse, 'brandPlans', 'current'],
    () => fetchCurrentBrandPlan({ workspaceId: workspaceIdToUse }),
    {
      refetchOnWindowFocus: false,
      staleTime: (options?.cacheTime || 0) * 0.5,
      ...options,
    },
  )
}
